import axios from "axios";
import {url} from "@/service/BASE_URL";

const URL = `${url}/api/university`;

function jwtConfig(jwt) {
  return { headers: { Authorization: `Bearer ${jwt}` } };
}

export default {
  getAll(jwt) {
    return axios.get(URL, jwtConfig(jwt));
  },
  getOne(id, jwt) {
    return axios.get(`${URL}/${id}`, jwtConfig(jwt));
  },
  getByGroup(id, jwt) {
    return axios.get(`${URL}/by-group/${id}`, jwtConfig(jwt));
  },
  save(payload, jwt) {
    return axios.post(URL, payload, jwtConfig(jwt));
  },
  edit(payload, id, jwt) {
    return axios.put(`${URL}/${id}`, payload, jwtConfig(jwt));
  },
  delete(id, jwt) {
    return axios.delete(`${URL}/${id}`, jwtConfig(jwt));
  },
};
